import { render, staticRenderFns } from "./print-activo-template.vue?vue&type=template&id=5bd3c22e&scoped=true&"
import script from "./print-activo-template.vue?vue&type=script&lang=js&"
export * from "./print-activo-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd3c22e",
  null
  
)

export default component.exports